export default __webpack_public_path__ + "elevator.png?4abb11aff9d5e5eebe24b1e275a74da0";